// extracted by mini-css-extract-plugin
export default {"wrapper":"SocialNetworks_wrapper__cTy94","disabled":"SocialNetworks_disabled__SRFBl","content":"SocialNetworks_content__jQW4h"};